// @flow
import _ from 'lodash';

import type { TDraftLeaguesReducer } from '../../types';

const getTeamsById = (state: TDraftLeaguesReducer) =>
	_.get(state, 'leagues.teams_by_id', {});

export default getTeamsById;